<template>
  <DialogHeader v-if="useMobileLayout">
    Infringement report
    <template #right>
      <div
        class="font-medium text-gray-800 cursor-pointer"
        @click="close"
      >
        Close
      </div>
    </template>
  </DialogHeader>
  <DialogContent class="pt-2.5">
    <div
      class="max-w-[400px] text-center text-[30px] leading-[36px] font-semibold font-primary text-gray-800 mb-[18px] mx-auto"
    >
      Proof of infringement report with
      <span
        class="w-fit bg-linear-to-r from-yellow-500 via-[#F84600] to-[#CE489A] bg-clip-text text-transparent font-medium"
      >
        Dacr AI
      </span>
    </div>

    <div class="text-center flex flex-col items-center">
      <div class="text-[15px] leading-[23px] text-gray-500 mb-1.5">
        Detailed
        <span class="font-medium text-gray-800">
          technical comparison analysis report
        </span>
        shows you precisely and technically where infringement is occurring on
        your work. Use it in court and for fighting any claim!
      </div>

      <Link>Learn more</Link>
    </div>

    <div class="w-full overflow-hidden">
      <img
        :src="InfringementImage"
        class="relative left-1/2 w-[130%] max-w-none -translate-x-1/2"
      />
    </div>

    <div class="w-full h-px bg-gray-900/10 mb-5"></div>

    <div
      class="w-full flex tablet-h:items-end justify-between! flex-col tablet-h:flex-row gap-5"
    >
      <div>
        <div
          class="text-[14px] font-medium font-secondary text-gray-400 mb-0.5"
        >
          Comparison analysis report
        </div>
        <div class="text-[34px] leading-[38px] font-primary font-semibold">
          $20
        </div>
      </div>

      <UiButton
        class="w-full tablet-h:w-auto"
        primary
        large
        @click="handleClick"
        >Get report</UiButton
      >
    </div>
  </DialogContent>
</template>

<script setup lang="ts">
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import { useDevice } from '@/shared/composables/useDevice'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'
import Link from '@/shared/components/Link.vue'
import InfringementImage from '@/assets/images/Infringement.png'
import { UiButton } from '@dacr/ui'
import { useUserStore } from '@/shared/stores/user'
import { computed, inject } from 'vue'

const userStore = useUserStore()
const { close, open, triggerEvent } = useDialog()
const { isMobile } = useDevice()

const isModal = inject<boolean>('dialogModal', false)
const useMobileLayout = computed(() => isMobile.value && !isModal)

const handleClick = () => {
  if (triggerEvent('success')) {
    return
  }

  if (!userStore.user?.reportCredits) {
    return open(Dialogs.BuyReportCredits)
  }

  return open(Dialogs.CreateReport)
}
</script>
